import { call, put, takeLatest, takeEvery } from "redux-saga/effects";

import * as addressApi from "@/api/address";

import {
  FETCH_ADDRESS_LIST,
  FETCH_ADDRESS_LIST_START,
  FETCH_ADDRESS_LIST_SUCCESS,
  FETCH_ADDRESS_LIST_FAIL,
  ADD_ADDRESS,
  ADD_ADDRESS_START,
  ADD_ADDRESS_FAIL,
  ADD_ADDRESS_SUCCESS,
  UPDATE_ADDRESS,
  UPDATE_ADDRESS_START,
  UPDATE_ADDRESS_FAIL,
  UPDATE_ADDRESS_SUCCESS,
  DELETE_ADDRESS,
  DELETE_ADDRESS_START,
  DELETE_ADDRESS_FAIL,
  DELETE_ADDRESS_SUCCESS,
} from "../../reducers/shopping/addresses/actions";

function* fetchAddressList({ meta }) {
  try {
    yield put({ type: FETCH_ADDRESS_LIST_START });
    const addressList = yield call(addressApi.fetchAddressList);
    yield put({ type: FETCH_ADDRESS_LIST_SUCCESS, payload: addressList, meta });
  } catch (err) {
    yield put({ type: FETCH_ADDRESS_LIST_FAIL, payload: err, error: true, meta });
  }
}

function* addAddress({ meta, payload }) {
  try {
    yield put({ type: ADD_ADDRESS_START });
    const address = yield call(addressApi.addAddress, payload);
    yield put({ type: ADD_ADDRESS_SUCCESS, payload: address, meta });
    yield put({ type: FETCH_ADDRESS_LIST, meta: { thunk: true } });
  } catch (err) {
    yield put({ type: ADD_ADDRESS_FAIL, payload: err, error: true, meta });
  }
}

function* updateAddress({ meta, payload }) {
  try {
    yield put({ type: UPDATE_ADDRESS_START });
    const address = yield call(addressApi.updateAddress, payload);
    yield put({ type: UPDATE_ADDRESS_SUCCESS, payload: address, meta });
    yield put({ type: FETCH_ADDRESS_LIST, meta: { thunk: true } });
  } catch (err) {
    yield put({ type: UPDATE_ADDRESS_FAIL, payload: err, error: true, meta });
  }
}

function* deleteAddress({ meta, payload }) {
  try {
    yield put({ type: DELETE_ADDRESS_START });
    const address = yield call(addressApi.deleteAddress, payload);
    yield put({ type: DELETE_ADDRESS_SUCCESS, payload: address });
    yield put({ type: FETCH_ADDRESS_LIST, meta: { thunk: true } });
  } catch (err) {
    yield put({ type: DELETE_ADDRESS_FAIL, payload: err, error: true, meta });
  }
}

// function* addAddress({ payload, meta }) {
//   try {
//     yield put({ type: ADD_ADDRESS_START });
//     const addressList = yield call(addressApi.fetchAddressList);
//     yield put({ type: ADD_ADDRESS_SUCCESS, payload: addressList });
//   } catch (err) {
//     yield put({ type: ADD_ADDRESS_FAIL, payload: err, error: true });
//   }
// }

export default function* addressesSaga() {
  yield takeLatest(FETCH_ADDRESS_LIST, fetchAddressList);
  yield takeEvery(ADD_ADDRESS, addAddress);
  yield takeEvery(UPDATE_ADDRESS, updateAddress);
  yield takeEvery(DELETE_ADDRESS, deleteAddress);
}
